export const modes = { normal: Symbol.for("normal"), insert: Symbol.for("insert") };
